(() => {
  let l = (e) => {
      var t = e.querySelectorAll(".slideshow__video video");
      e.swiper && e.swiper.initialized
        ? t.forEach((e) => {
            e.closest(".swiper-slide-visible") ? e.play() : e.pause();
          })
        : e.closest('[data-slide-count="1"]') &&
          t.forEach((e) => {
            e.play();
          });
    },
    t = (t) => {
      t &&
        t.classList.contains("section-slideshow") &&
        new IntersectionObserver((e) => {
          e.forEach((r) => {
            if (r.isIntersecting) {
              r = t.querySelector(".slideshow");
              if (r) {
                var a = r.querySelector(".swiper-button-prev"),
                  o = r.querySelector(".swiper-button-next"),
                  s = {
                    speed: 800,
                    autoHeight: !1,
                    allowTouchMove: !0,
                    mousewheel: { forceToAxis: !0 },
                    watchSlidesProgress: !0,
                    preventInteractionOnTransition: !0,
                  };
                let i = (e) => {
                  var t =
                      window.innerWidth ||
                      document.documentElement.clientWidth ||
                      document.body.clientWidth,
                    r = e.activeIndex,
                    r = e.slides[r];
                  let i = 0,
                    a;
                  (e.el.parentNode.classList.contains(
                    "slideshow__swiper--simple",
                  ) && ((a = e.el.parentNode), (i = 990)),
                    (e.el.classList.contains("slideshow__swiper--overlay") ||
                      e.el.classList.contains("slideshow__swiper--grid")) &&
                      (i = 0));
                  e = [
                    e.navigation.nextEl,
                    e.navigation.prevEl,
                    e.pagination.el,
                    ...(a ? [a] : []),
                  ];
                  if (t >= i) {
                    let i = r.dataset.colorScheme;
                    e.forEach((t) => {
                      if (t) {
                        let e = t.getAttribute("class");
                        ((e = e.replace(/color-background-\d+/g, "")),
                          t.setAttribute("class", e),
                          t.classList.add(i));
                      }
                    });
                  } else
                    e.forEach((t) => {
                      if (t) {
                        let e = t.getAttribute("class");
                        ((e = e.replace(/color-background-\d+/g, "")),
                          t.setAttribute("class", e));
                      }
                    });
                };
                if (
                  ("true" === r.getAttribute("data-autoplay") &&
                    (s.autoplay = { disableOnInteraction: !0 }),
                  "true" === r.getAttribute("data-pagination") &&
                    (s.pagination = {
                      el: ".swiper-pagination",
                      type: "bullets",
                      clickable: !1,
                    }),
                  "true" === r.getAttribute("data-navigation") &&
                    (s.navigation = { nextEl: o, prevEl: a }),
                  "true" === r.getAttribute("data-parallax") &&
                    "grid" !== r.getAttribute("data-layout") &&
                    (s.parallax = !0),
                  "true" === r.getAttribute("data-enable-loop") &&
                    (s.loop = !0),
                  "grid" === r.getAttribute("data-layout") &&
                    (s.breakpoints = { 750: { slidesPerView: "auto" } }),
                  1 < Number(r.getAttribute("data-slide-count")))
                )
                  if ("simple" === r.getAttribute("data-layout")) {
                    var o = r.querySelector(".slideshow__swiper--text");
                    let t = r.querySelector(".slideshow__swiper--media");
                    if (o && t) {
                      let e = new Swiper(o, s);
                      var a = new Swiper(t, {
                        ...s,
                        autoplay: !1,
                        pagination: !1,
                        navigation: !1,
                        parallax: !1,
                      });
                      (((e.controller.control = a).controller.control = e),
                        i(e),
                        e.on("beforeTransitionStart", function () {
                          i(this);
                        }),
                        a.on("beforeTransitionStart", function () {
                          i(e);
                        }),
                        a.on("slideChange", function () {
                          l(t);
                        }));
                    }
                  } else if ("overlay" === r.getAttribute("data-layout")) {
                    let e = r.querySelector(".slideshow__swiper--overlay");
                    e &&
                      ((o = new Swiper(e, {
                        ...s,
                        effect: "creative",
                        creativeEffect: {
                          prev: { translate: [0, 0, -400] },
                          next: { translate: ["100%", 0, 0] },
                        },
                      })),
                      i(o),
                      o.on("beforeTransitionStart", function () {
                        i(this);
                      }),
                      o.on("slideChange", function () {
                        l(e);
                      }));
                  } else if ("grid" === r.getAttribute("data-layout")) {
                    let e = r.querySelector(".slideshow__swiper--grid");
                    e &&
                      ((a = new Swiper(e, s)),
                      i(a),
                      a.on("beforeTransitionStart", function () {
                        i(this);
                      }),
                      a.on("slideChange", function () {
                        l(e);
                      }));
                  }
              }
            }
          });
        }).observe(t);
    },
    i = (e) => {
      if (e && e.classList.contains("section-slideshow")) {
        let i = e.querySelector(".slideshow"),
          r;
        (i && "simple" === i.getAttribute("data-layout")
          ? (r = e.querySelector(".slideshow__swiper--media"))
          : i && "overlay" === i.getAttribute("data-layout")
            ? (r = e.querySelector(".slideshow__swiper--overlay"))
            : i &&
              "grid" === i.getAttribute("data-layout") &&
              (r = e.querySelector(".slideshow__swiper--grid")),
          new IntersectionObserver((e) => {
            e.forEach((e) => {
              var t;
              e.isIntersecting
                ? r &&
                  (l(r), r.swiper) &&
                  "true" === i.getAttribute("data-autoplay") &&
                  r.swiper.autoplay.resume()
                : r &&
                  ((e = r),
                  (t = e.querySelectorAll(".slideshow__video video")),
                  e.swiper && e.swiper.initialized
                    ? t.forEach((e) => {
                        e.pause();
                      })
                    : e.closest('[data-slide-count="1"]') &&
                      t.forEach((e) => {
                        e.play();
                      }),
                  r.swiper) &&
                  "true" === i.getAttribute("data-autoplay") &&
                  r.swiper.autoplay.pause();
            });
          }).observe(e));
      }
    };
  (t(document.currentScript.parentElement),
    i(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      (t(e.target), i(e.target));
    }));
})();
